import { Global, Module } from '@nestjs/common';
import { InventoryLedgerService } from './inventory-ledger.service';

/**
 * Global because the ledger is written from wherever stock moves — products,
 * variants, cart validation, checkout — and threading it through every module's
 * imports would say less about the design than this does.
 */
@Global()
@Module({
  providers: [InventoryLedgerService],
  exports: [InventoryLedgerService],
})
export class InventoryModule {}
